import { render } from "./Reference.vue?vue&type=template&id=78cae94b&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"

import "./Reference.vue?vue&type=style&index=0&id=78cae94b&scoped=true&lang=scss"
import "./Reference.vue?vue&type=style&index=1&id=78cae94b&lang=css"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cae94b"]])

export default __exports__